/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import * as React from 'react';
import {
  Box,
  Table,
  TableCell,
  TableHead,
  Typography,
  TableBody,
  Link,
  TableContainer,
  TableRow,
  Card,
  useTheme
} from '@mui/material';
import useMounted from '../../../hooks/useMounted';
import { useState, useEffect, useCallback } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import moment from 'moment';
import { relaunchApi } from '../../../api/relaunchApi';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { alpha } from '@mui/material/styles';
import { toneAlpha, lightVeil, greyAlpha, grey } from '../../../theme/tones';

const RelaunchRecallsList = () => {
  const theme = useTheme();
  const { endDateRelaunch, state } = useParams();
  const mounted = useMounted();
  const [rows, setRows] = useState([]);

  const getRelaunchInfo = useCallback(async () => {
    try {
      const data = await relaunchApi.getRelaunchInfo(endDateRelaunch, state, localStorage.getItem('accessToken'));
      if (data.length === 0) {
        throw new Error('L\'apprenant n\'existe pas');
      }
      if (mounted.current) {
        setRows(data.recalls);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted, endDateRelaunch, state]);

  useEffect(() => {
    getRelaunchInfo();
  }, [getRelaunchInfo]);

  return (
    <Card
      sx={{
        borderRadius: '24px',
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        backdropFilter: 'blur(20px)',
        boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
        overflow: 'hidden'
      }}
    >
      <Box sx={{ p: 3, borderBottom: `1px solid ${theme.palette.divider}`, bgcolor: 'action.hover' }}>
        <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', letterSpacing: '-0.01em' }}>
          Rendez-vous téléphoniques
        </Typography>
      </Box>
      <TableContainer sx={{ maxHeight: 355 }}>
        <Table sx={{ minWidth: 600 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.mode === 'light' ? grey(50) : greyAlpha(900, 0.1) }}>
              <TableCell sx={{ fontWeight: 700, color: 'text.secondary', py: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>Nom</TableCell>
              <TableCell sx={{ fontWeight: 700, color: 'text.secondary', py: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>Commentaire</TableCell>
              <TableCell sx={{ fontWeight: 700, color: 'text.secondary', py: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>Date de rappel</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 6, color: 'text.secondary', fontStyle: 'italic' }}>
                  Aucun rendez-vous téléphonique prévu
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row) => {
                const isOverdue = moment(row.recall_date).unix() < moment().unix();
                return (
                  <TableRow
                    key={`${row.id}-${row.recall_date}`}
                    sx={{
                      borderBottom: theme.palette.mode === 'light' ? `1px solid ${grey(100)}` : `1px solid ${lightVeil(0.03)}`,
                      bgcolor: isOverdue 
                        ? (theme.palette.mode === 'light' ? toneAlpha('rose', 0.02) : toneAlpha('rose', 0.04))
                        : 'transparent',
                      '&:hover': {
                        bgcolor: 'action.hover'
                      }
                    }}
                  >
                    <TableCell sx={{ py: 2.5, fontWeight: 700 }}>
                      <Link
                        component={RouterLink}
                        to={`/dashboard/customers/${row.id}`}
                        sx={{
                          textDecoration: 'none',
                          color: 'primary.main',
                          fontWeight: 700,
                          fontSize: '0.85rem',
                          '&:hover': { color: 'primary.dark' }
                        }}
                      >
                        {row.firstname} {row.lastname}
                      </Link>
                    </TableCell>
                    <TableCell sx={{ py: 2.5, color: 'text.secondary', fontWeight: 500, fontSize: '0.85rem', maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {row.comment || 'Aucun commentaire.'}
                    </TableCell>
                    <TableCell sx={{ py: 2.5 }}>
                      <Box
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 1,
                          px: 1.5,
                          py: 0.5,
                          borderRadius: '12px',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          backgroundColor: isOverdue
                            ? (theme.palette.mode === 'light' ? toneAlpha('rose', 0.08) : toneAlpha('rose', 0.15))
                            : (theme.palette.mode === 'light' ? toneAlpha('blue', 0.08) : toneAlpha('blue', 0.15)),
                          color: isOverdue ? 'error.main' : 'primary.main',
                          border: '1px solid',
                          borderColor: 'transparent'
                        }}
                      >
                        {isOverdue ? <ErrorOutlineIcon sx={{ fontSize: 14 }} /> : <CalendarTodayIcon sx={{ fontSize: 13 }} />}
                        {moment(row.recall_date).format('DD/MM/YYYY, HH:mm')}
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default RelaunchRecallsList;
